import React from "react";
import styled from "@emotion/styled";

import { Skill } from "@/services/UserService";

import Feature from "../Feature";

const StyledItemsContainer = styled.ul`
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem;

  & > * {
    margin-top: 1.5rem;
  }
`;

const SkillsDisplay: React.FC<{ skills: Skill[]; className?: string }> = ({
  skills,
  className,
}) => {
  return (
    <StyledItemsContainer className={className}>
      {skills.map((skill, i) => (
        <li key={i}>
          <Feature title={skill} />
        </li>
      ))}
    </StyledItemsContainer>
  );
};

export default SkillsDisplay;
